import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookies from "vue-cookies";
import BootstrapVue from "bootstrap-vue";
// import VueAnalytics from "vue-analytics";
import { Observable } from "rxjs";

import BzbsApi from "@/core/Http/BzbsApi.js";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

import Config from "@/config/vueconfig.js";
import Validator from "@/plugins/Validator.js";
import ga from "@/plugins/GA.js";
import BBEnumCampaignType from "@/plugins/BBEnumCampaignType.js";
import RegExp from "@/plugins/RegExp.js";
import Filter from "@/plugins/Filter.js";
import Account from "@/helper/AccountHelper.js";
import Cache from "@/helper/Cache.js";
import CacheHelper from "@/helper/CacheHelper.js";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Antd from 'ant-design-vue/lib'
import "ant-design-vue/dist/antd.css"; // or 'ant-design-vue/dist/antd.less'

import * as VueGoogleMaps from "vue2-google-maps";

// import device from "vue-device-detector-js";

//open vue analytice and ant design in need and only used item not whole library by {}
Vue.config.productionTip = false;
Vue.use(VueCookies);
// Vue.use(Antd);
Vue.use(Config);
Vue.use(Validator);
Vue.use(ga);
Vue.use(BBEnumCampaignType);
Vue.use(RegExp);
Vue.use(Filter);
Vue.use(BootstrapVue);
// Vue.use(device);

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDnEgxgne2--rT_d3ZWTns0dnkLiKWvfgE",
        libraries: "places",
    },
});

new Vue({
    router,
    store,
    render: (h) => h(App),
    data() {
        return {
            checkRegister: null,
        };
    },
    mounted: function () {
        var cacheHelper = new CacheHelper("cookie");
        this.checkRegister = cacheHelper.getCache("BzbsUser");
        // if (this.checkRegister == null) {
        //     this.$router.push('/linelogin');
        // }
    },
    created: function () {
        Vue.initFinished = false;

        // Vue.use(VueAnalytics, {
        //     id: Vue.bzbsConfig.bzbsGaId,
        //     autoTracking: {
        //         page: false
        //     }
        // });

        this.initAccount();
        this.initFirebaseTracking();
        this.getAzureConfig();
    },
    methods: {
        initAccount: function () {
            Vue.subInitList = [];
            var observInit = new Observable((subscriber) => {
                Vue.subInitList.push(subscriber);
            });
            Vue.observInit = observInit;

            observInit.subscribe((profile) => {
                // console.log("init profile", profile);
                this.$store.commit("setAllProfile", profile);
            });
            Account.initial();
        },
        initFirebaseTracking: function () {
            // tutorial https://razbakov.com/vue-google-firebase-analytics/
            var config = Vue.bzbsConfig.firebase;
            if (config.apiKey) {
                firebase.initializeApp(config);
                firebase.analytics();
                Vue.prototype.$analytics = firebase.analytics();
            }
        },
        getAzureConfig() {
            if (Cache.get("bzbsConfig")) {
                var url;
                if (window.location.hostname == "localhost") {
                    url =
                        "https://dev-web-nescafestreetcafe.azurewebsites.net/api/config";
                } else {
                    url = window.location.origin + "/api/version";
                }
                BzbsApi.connectBzbsGetBlob(url).subscribe((res) => {
                    let azureConfig = {
                        bzbsUrl: res.data.apiurl,
                        client_id: res.data.app_id,
                        appname: res.data.app_name,
                        bzbsBlobUrl: res.data.blob,
                        lineLiffId: res.data.liff_id,
                        bzbsModuleUrl: res.data.module,
                        bzbsDelivery: res.data.module_delivery,
                        shopingmoduleCartUrl: res.data.module_shopping,
                        prefix: res.data.prefix,
                        shopingCartUrl: res.data.web_shopping,
                    };
                    Cache.set("bzbsConfig", azureConfig);
                });
            }
        },
    },
}).$mount("#app");
